import React, { Suspense } from 'react';

const Notifications = React.lazy(() => import(/* webpackChunkName: "Notifications" */ './Notifications'));

const DatastoreNotificationsProvider = React.lazy(() =>
    import(/* webpackChunkName: "Notifications" */ './data/DatastoreNotificationsProvider')
);

export default class NotificationsLoader {
    constructor(config) {
        this.config = this._parseConfiguration(config);
    }

    getComponent() {
        const component = <Notifications {...this.config} />;
        const dataProvider = this._getDataProvider(component);

        return (
            <Suspense
                fallback={
                    <div className="notifications-loader">
                        <svg className="notifications-loader__icon">
                            <title>Loading notifications</title>
                            <use href="#notification" />
                        </svg>
                    </div>
                }
            >
                {dataProvider}
            </Suspense>
        );
    }

    _parseConfiguration(config) {
        return {
            ...config,
        };
    }

    _getDataProvider(component) {
        const { datasource, datasourceUrl, datasourceJWT } = this.config;

        if (datasource === 'datastore') {
            const datastore = new Datastore({
                serviceURL: datasourceUrl,
                jwtURL: datasourceJWT,
            });

            return <DatastoreNotificationsProvider datastore={datastore}>{component}</DatastoreNotificationsProvider>;
        }

        return component;
    }
}
